import React, { useEffect } from 'react'

function Item( props ) {
    useEffect(() => {
        // console.log(props);
    }, []);

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        notation: 'compact',
        compactDisplay: 'short',
        maximumFractionDigits: 1, // Number of decimal places
    });

    const handleAccordion = (e) => {
        setTimeout(() => {
            if(e.target.classList.contains('collapsed')) {
                props.updateCurrentItem(null);
            } else {
                props.updateCurrentItem(e.target.dataset.slug);
            }
        }, 10);
    };

    const handleOffice = (e) => {
        setTimeout(() => {
            if(e.target.classList.contains('collapsed')) {
                props.updateCurrentItem(null);
            } else {
                props.updateCurrentItem(e.target.dataset.slug);
            }
            e.target.classList.toggle('collapsed');
        }, 10);
    };

    return (
        <div className={`card timeline-item timeline-item--${props.type}`}>
            <div className="card-header" id={`accordion-${props.slug}-heading`}>
                <h4 className="accordion-header timeline-item-name">
                    {props.type === 'ma' && (
                        <button className={`btn btn-link text-left accordion-button ${props.slug === props.currentItem ? '' : 'collapsed'}`} type="button" data-toggle="collapse" data-target={`#accordion-${props.slug}-content`} aria-expanded={props.slug === props.currentItem ? true : false} aria-controls={`accordion-${props.slug}-content`} onClick={handleAccordion} data-slug={props.slug}>
                            {props.name}
                            {parseInt(props.aum) > 0 &&
                                <span>Added {formatter.format(props.aum)} AUM</span>
                            }
                        </button>
                    )}
                    {props.type === 'office' && (
                        <button className={`btn btn-link text-left`} type="button" onClick={handleOffice} data-slug={props.slug}>{props.name} <span>Added Office</span></button>
                    )}
                </h4>
            </div>
            {props.type === 'ma' && (
                <div id={`accordion-${props.slug}-content`} className={`accordion-collapse collapse ${props.slug === props.currentItem ? 'show' : ''}`} aria-labelledby={`accordion-${props.slug}-heading`} data-parent={`#ma-accordion`}>
                    <div className="card-body">
                        {/* {parseInt(props.aum) > 0 &&
                            <p className="timeline-item-aum">Added {moneyFormat(props.aum)} AUM</p>
                        } */}
                        {props.logo &&
                            <img src={props.logo} alt="" />
                        }
                        {props.asOfDate &&
                            <p className="timeline-item-as-of-date">As of {props.asOfDate}</p>
                        }
                        {props.description &&
                            <div className="timeline-item-description">
                            <p>{props.description}</p>
                            </div>
                        }
                    </div>
                </div>
            )}
        </div>

        // <div id={`#accordion-${props.slug}`} className={`timeline-item timeline-item--${props.type} accordion-item`}>
        //     <h4 className="accordion-header timeline-item-name">
        //         <button className="accordion-button" data-bs-toggle="collapse" data-bs-target={`#accordion-${props.slug}-content`} aria-expanded={props.slug === props.currentItem ? true : false} aria-controls={`accordion-${props.slug}-content`} onClick={handleAccordion} data-slug={props.slug}>{props.name}</button>
        //     </h4>
        //     <div id={`accordion-${props.slug}-content`} className={`accordion-collapse collapse ${props.slug === props.currentItem ? 'show' : ''}`} data-bs-parent={`#accordion-${props.slug}`}>
        //         {parseInt(props.aum) &&
        //             <p className="timeline-item-aum">{moneyFormat(props.aum)}</p>
        //         }
        //         {props.description &&
        //             <div className="timeline-item-description">
        //             <p>{props.description}</p>
        //             </div>
        //         }
        //     </div>
        // </div>
    );
}

export default Item;
